<template>
 <b-modal ref="modal" centered visible size="lg" content-class="dropshipment-products-modal"  :hide-footer="true" title="Product overzicht" @hidden="$emit('close')">
    <div>
        <api-table-block ref="productsTable" :fields="fields" :items="findAllProducts" default-sort-by="created_at" item-label-singular="product" item-label-plural="producten">
        <template slot="name" slot-scope="data">
            <a href="#" @click.prevent="details(data.item)">{{data.value}}</a>
        </template>
        <template slot="price" slot-scope="data">
            <sale-price-editable v-if="data.item.sale_price" :price="data.item.price" :sale_price="data.item.sale_price" :product-id="data.item.id" :key="data.item.id"></sale-price-editable>
            <price-editable v-else :price="data.item.price" :product-id="data.item.id" :key="data.item.id" ></price-editable>
        </template>
        <template slot="stock_quantity" slot-scope="data">
            <stock-editable :quantity="data.value" :product-id="data.item.id" :key="data.item.id"></stock-editable>
        </template>
        <template slot="location" slot-scope="data">
            <div>
            <location-editable field="location" :value="data.item.location" :product-id="data.item.id" :key="data.item.id"></location-editable>
            </div>
            <div>
            <small>
                Rest:
                <field-editable field="overstock_location" :value="data.item.overstock_location" :product-id="data.item.id" :key="data.item.id"></field-editable>
            </small>
            </div>
        </template>
        </api-table-block>
        <product-detail-modal v-if="detailModalProductId" :key="detailModalProductId" :product-id="detailModalProductId" @close="detailModalProductId = null" @remove="refresh"></product-detail-modal>
    </div>
 </b-modal>
</template>

<script>
import http from '../utils/http'
import LocationEditable from '../products/LocationEditable'
import FieldEditable from '../products/FieldEditable'
import StockEditable from '../products/StockEditable'
import PriceEditable from '../products/PriceEditable'
import SalePriceEditable from '../products/SalePriceEditable'
import ApiTableBlock from '../common/ApiTableBlock'
import ProductDetailModal from '../products/ProductDetailModal'

export default {
  components: {
    LocationEditable,
    FieldEditable,
    StockEditable,
    PriceEditable,
    SalePriceEditable,
    ApiTableBlock,
    ProductDetailModal
  },
  props: {
    vendor: Object
  },
  data () {
    return {
      fields: {
        name: {
          label: 'Product',
          thStyle: 'width: 30%;',
          sortable: true
        },
        price: {
          label: 'Prijs',
          thStyle: 'width: 20%;',
          sortable: true
        },
        stock_quantity: {
          label: 'Voorraad',
          thStyle: 'width: 20%;',
          sortable: true
        },
        location: {
          label: 'Locaties',
          thStyle: 'width: 20%;',
          sortable: true
        }
      },
      detailModalProductId: null
    }
  },
  methods: {
    findAllProducts (params) {
      params['filter[dropship]'] = this.vendor.type

      return http.get('/products', { params })
    },
    details (product) {
      this.detailModalProductId = product.id
    },
    refresh () {
      this.$refs.productsTable.refresh()
    }
  }
}
</script>
<style>
.dropshipment-products-modal {
    width: 1400px;
}
</style>


// WEBPACK FOOTER //
// DropshipmentProductsTable.vue?5e84234f